import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Field wrapper: renders helper/error text *below* a projected control, matching
 * the Papercast `Input` design (12px semibold, ink-2 for help, danger for error).
 *
 * In the design the field's own label floats *inside* the control (see
 * `app-text-input`/`app-select`), so most fields need no `label` here. `label`
 * remains available as an optional heading for grouping controls that can't
 * carry a floating label (e.g. a map + coordinate pair).
 *
 *   <app-text-input label="Client ID" [(ngModel)]="clientId" />
 *   <app-form-field [error]="idInvalid ? 'Client ID is required' : null">
 *     <app-text-input label="Client ID" [(ngModel)]="clientId" />
 *   </app-form-field>
 */
@Component({
  selector: 'app-form-field',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
  template: `
    <div class="flex flex-col gap-2">
      @if (label()) {
        <label class="px-2 text-[12px] font-semibold leading-none text-ink-2">{{ label() }}</label>
      }
      <ng-content />
      @if (error()) {
        <span class="px-2 text-[12px] font-semibold leading-4 text-danger">{{ error() }}</span>
      } @else if (help()) {
        <span class="px-2 text-[12px] font-semibold leading-4 text-ink-2">{{ help() }}</span>
      }
    </div>
  `,
})
export class FormField {
  readonly label = input('');
  readonly help = input('');
  /** When set, shown in danger colour instead of `help`. */
  readonly error = input<string | null>(null);
}
